export var SocketEvent;
(function (SocketEvent) {
    SocketEvent["app_error"] = "app:error";
    SocketEvent["app_error_invalid_payload"] = "app:error:invalid_payload";
    SocketEvent["context_update"] = "session:context:update";
    SocketEvent["context_updated"] = "session:context:updated";
    SocketEvent["conversation_closed"] = "conversation:closed";
    SocketEvent["conversation_reopen"] = "conversation:reopen";
    SocketEvent["conversation_reopened"] = "conversation:reopened";
    SocketEvent["conversation_email_send"] = "conversation:email:send";
    SocketEvent["conversation_email_send_success"] = "conversation:email:send:success";
    SocketEvent["conversation_email_send_error"] = "conversation:email:send:error";
    SocketEvent["member_join"] = "conversation:member_join";
    SocketEvent["member_leave"] = "conversation:member_leave";
    SocketEvent["message_brain_received"] = "message:brain_received";
    SocketEvent["message_compose"] = "message:compose";
    SocketEvent["message_delivered"] = "message:delivered";
    SocketEvent["message_read"] = "message:read";
    SocketEvent["message_received"] = "message:received";
    SocketEvent["message_send"] = "message:send";
    SocketEvent["message_send_sync"] = "message:send:sync";
    SocketEvent["session_files_upload_request"] = "file:upload_url:create";
    SocketEvent["session_files_upload_request_success"] = "file:upload_url:created";
    SocketEvent["session_files_upload_request_error"] = "file:upload_url:create:error";
    SocketEvent["session_files_download_request"] = "file:download_url:create";
    SocketEvent["session_files_download_request_success"] = "file:download_url:created";
    SocketEvent["session_files_download_request_error"] = "file:download_url:create:error";
    SocketEvent["session_activity"] = "session:activity";
    SocketEvent["session_overview"] = "session:overview";
    SocketEvent["session_close"] = "session:close";
    SocketEvent["session_close_error"] = "session:close:error";
    SocketEvent["session_closed"] = "session:closed";
    SocketEvent["session_create"] = "session:create";
    SocketEvent["session_create_error"] = "session:create:error";
    SocketEvent["session_created"] = "session:created";
    SocketEvent["session_expired"] = "session:expired";
    SocketEvent["session_history_error"] = "session:history:sync:error";
    SocketEvent["session_history_sync"] = "session:history:sync";
    SocketEvent["session_history_synced"] = "session:history:synced";
    SocketEvent["session_leader"] = "session:leader";
    SocketEvent["session_max_concurrent"] = "session:max_concurrent";
    SocketEvent["session_rated"] = "session:rated";
    SocketEvent["session_rating"] = "session:rating";
    SocketEvent["message_rating"] = "message:rating";
    SocketEvent["session_rating_error"] = "session:rating:error";
    SocketEvent["session_reconnect"] = "session:reconnect";
    SocketEvent["session_reconnect_error"] = "session:reconnect:error";
    SocketEvent["session_reconnect_forbidden"] = "session:reconnect:forbidden";
    SocketEvent["session_reconnected"] = "session:reconnected";
})(SocketEvent || (SocketEvent = {}));
/**
 * State in which the Web chat could be.
 * This allows asyncronous execution of session creation or reconnection.
 */
export var WebChatState;
(function (WebChatState) {
    WebChatState["Idle"] = "idle";
    WebChatState["Create"] = "create";
    WebChatState["Creating"] = "creating";
    WebChatState["Reconnect"] = "reconnect";
    WebChatState["Reconnecting"] = "reconnecting";
    WebChatState["Synchronize"] = "synchronize";
    WebChatState["Synchronizing"] = "synchronizing";
    WebChatState["Synchronized"] = "synchronized";
    WebChatState["Error"] = "error";
    WebChatState["Init"] = "init";
})(WebChatState || (WebChatState = {}));
